import { GRAPHQL_API } from '../core/constants/api'
import { PUBLIC_API_URL } from '../core/constants/env'

const apiConfiguration = {
  domain: PUBLIC_API_URL,
  graphQL: `${PUBLIC_API_URL}${GRAPHQL_API}`
}

export default apiConfiguration
